import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ProjectCIDRPanel extends PureComponent {
  static propTypes = {
    cidrClassPrefix: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    copyKey: "project_settings.cidr_panel"
  };

  render() {
    const { cidrClassPrefix, disabled, copyKey, copy } = this.props;

    return (
      <Segment className="clear-both" disabled={disabled}>
        <Header as="h3">{copy(`${copyKey}.title`)}</Header>
        <p>{copy(`${copyKey}.body`)}</p>
        <p>
          <strong>{`${cidrClassPrefix}.0.0/16 - ${cidrClassPrefix}.255.255/16`}</strong>
        </p>
        <p>{copy(`${copyKey}.restriction_message`)}</p>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ProjectCIDRPanel);
